<template>
  <div class="d-flex flex-column w-100">
    <Navbar />

    <div id="main-content" class="p-2">
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
  //#region Imports
  import Navbar from '@/shared/components/menues/Navbar.vue';
  //#endregion
</script>

<style lang="scss">
  @import './assets/sass/main.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100vh;
    display: flex;
  }

  #main-content {
    height: 100%;
    background: rgb(242, 243, 248);
    margin-top: 62px;
  }

  /* Custom scrollbar styling */
  /* Webkit-based browsers (Chrome, Safari) */
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Firefox */
  body {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
  }
</style>
